/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ChannelComponent as ɵa} from './lib/components/biztype/channel/channel.component';